module.exports = __webpack_public_path__ + "img/sensuu.a8997a56.svg";